import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Swal from "sweetalert2";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import * as XLSX from "xlsx";
import excelFile from "../../../ExcelFiles/ShortBulkUpload.xlsx";
import { MdFileDownload } from "react-icons/md";

function BulkImport() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const fileInputRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [getCustomer, setGetCustomer] = useState([]);
    const [getVendor, setGetVendor] = useState([]);
    const [getMode, setGetMode] = useState([]);
    const [error, setError] = useState(null);
    const [getCity, setGetCity] = useState([]);

    const [form, setForm] = useState({
        Customer_Code: JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
        mode: "",
        Dox_Spx: "Dox",
        FromDate: firstDayOfMonth
    });

    const handleDownloadTemplate = () => {
      const link = document.createElement("a");
      link.href = excelFile;
      link.download = "ShortEntryUpload.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      };

    /* ================= FETCH MASTER DATA ================= */

    const fetchVendorData = async () => {
        try {
            const res = await getApi("/Master/getVendor");
            setGetVendor(Array.isArray(res.Data) ? res.Data : []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchCityData = async () => {

        try {
            const response = await getApi(`/Master/GetInterDomestic?Product_Type=International`);
            const data = response.data
            // Check if the response contains data, then update the corresponding state
            if (data) {
                setGetCity(Array.isArray(data) ? data : []);
            } else {
                setGetCity([]);
            }
        } catch (err) {
            console.error(`Error fetching data from /Master/GetInterDomestic:`, err);

        }

    };
    const fetchCustomerData = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("Login"));
            const res = await getApi(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}`)
            setGetCustomer(Array.isArray(res.Data) ? res.Data : []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchModeData = async () => {
        try {
            const res = await getApi("/Master/GetMode");
            setGetMode(Array.isArray(res.Data) ? res.Data : []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomerData();
        fetchModeData();
        fetchCityData();
        fetchVendorData();
    }, []);

    /* ================= OPTIONS ================= */

    const loginCustomerCode = JSON.parse(localStorage.getItem("Login"))?.Customer_Code;
    const customerOptions =

        [

            ...getCustomer.map((cust) => ({
                label: cust.Customer_Name,
                value: cust.Customer_Code,
            })),
        ]


    const modeOptions = getMode.map(p => ({
        label: p.Mode_Name,
        value: p.Mode_Code,
    }));

    const vendorOptions = getVendor.map(v => ({
        label: v.Vendor_Name,
        value: v.Vendor_Code,
    }));

    const cityOptions = getCity.map(c => ({
        label: c.City_Name,
        value: c.City_Code,
    }));

    /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.Customer_Code) {
        Swal.fire("Validation Error", "Customer Name is required", "warning");
        return;
    }

    if (!form.mode) {
        Swal.fire("Validation Error", "Mode Name is required", "warning");
        return;
    }

    if (!form.Dox_Spx) {
        Swal.fire("Validation Error", "Dox / Non Dox is required", "warning");
        return;
    }

    if (!form.FromDate) {
        Swal.fire("Validation Error", "Book Date is required", "warning");
        return;
    }

    if (!fileInputRef.current?.files[0]) {
        Swal.fire("Validation Error", "Please Select Excel File", "warning");
        return;
    }

    try {

        Swal.fire({
            title: "Reading Excel...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        const file = fileInputRef.current.files[0];

        const reader = new FileReader();

        reader.onload = async (event) => {

            try {

                const data = new Uint8Array(event.target.result);

                const workbook = XLSX.read(data, {
                    type: "array"
                });

                const sheetName = workbook.SheetNames[0];

                const worksheet = workbook.Sheets[sheetName];

                const exelData = XLSX.utils.sheet_to_json(worksheet);

                console.log(exelData);

                if (exelData.length === 0) {

                    Swal.close();

                    Swal.fire(
                        "Warning",
                        "No Excel Data Found",
                        "warning"
                    );

                    return;
                }

                Swal.update({
                    title: "Uploading..."
                });

                const payload = {

                    Customer_Code: form.Customer_Code,

                    Mode_Code: form.mode,

                    DoxSpx: form.Dox_Spx,

                    BookDate: form.FromDate.toLocaleDateString("en-GB"),

                    UserName: JSON.parse(localStorage.getItem("Login"))?.User_Name,

                    exelData

                };

                console.log(payload);

                const res = await postApi(
                    "/Booking/BankimportDocumentfile",
                    payload
                );

                Swal.close();

                if (res.Status === true) {

                    Swal.fire(
                        "Success",
                        `Upload Completed

Total : ${res.Total}

Success : ${res.SuccessCount}

Failed : ${res.FailedCount}`,
                        "success"
                    );

                    fileInputRef.current.value = "";

                    setForm({
                        Customer_Code: JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
                        mode: "",
                        Dox_Spx: "Dox",
                        FromDate: new Date()
                    });

                } else {

                    Swal.fire(
                        "Warning",
                        res.Message,
                        "warning"
                    );

                }

            } catch (err) {

                Swal.close();

                console.error(err);

                Swal.fire(
                    "Error",
                    err.message,
                    "error"
                );

            }

        };

        reader.readAsArrayBuffer(file);

    } catch (err) {

        Swal.close();

        Swal.fire(
            "Error",
            err.message,
            "error"
        );

    }

};


    /* ================= UI (UNCHANGED) ================= */

    return (
        <div className="body">
            <div className="container1">
                <form onSubmit={handleSubmit} >
                    <div className="fields2">

                        <div className="input-field1">
                            <label>Customer Name</label>
                            <Select
                                className="blue-selectbooking"
                                classNamePrefix="blue-selectbooking"
                                options={customerOptions}
                                value={customerOptions.find(c => c.value === form.Customer_Code) || null}
                                onChange={(opt) =>
                                    setForm({ ...form, Customer_Code: opt?.value || "" })
                                }
                                placeholder="Select Customer"
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>



                        <div className="input-field3">
                            <label>Mode Name</label>
                            <Select
                                className="blue-selectbooking"
                                classNamePrefix="blue-selectbooking"
                                options={modeOptions}
                                value={modeOptions.find(p => p.value === form.mode) || null}
                                onChange={(opt) =>
                                    setForm({ ...form, mode: opt?.value || "" })
                                }
                                placeholder="Select Mode"
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>

                        <div className="input-field3">
                            <label>Dox / Non Dox</label>
                            <Select
                                options={[
                                    { value: "Dox", label: "Dox" },
                                    { value: "Non Dox", label: "Non Dox" },

                                ]}
                                value={form.Dox_Spx ? { value: form.Dox_Spx, label: form.Dox_Spx } : null}
                                onChange={(selectedOption) =>
                                    setForm({ ...form, Dox_Spx: selectedOption.value })
                                }
                                placeholder="Select Dox / Non Dox"
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"

                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                }}
                            />

                        </div>



                        <div className="input-field3">
                            <label>Date</label>
                            <DatePicker
                                portalId="root-portal"
                                selected={form.FromDate}
                                onChange={(date) => setForm({ ...form, FromDate: date })}
                                dateFormat="dd/MM/yyyy"
                                className="form-control form-control-sm"
                            />
                        </div>



                        <div className="input-field3">
                            <label>Excel File</label>
                            <input
                                style={{ display: "flex", justifyContent: "center", paddingTop: "5px" }}
                                type="file"
                                ref={fileInputRef}
                                accept=".xlsx,.xls"
                                className="input"
                            />
                        </div>

                        <div className="bottom-buttons" style={{ marginTop: "22px", marginLeft: "10px" }}>
                            <button type="submit" className="ok-btn">Submit</button>
                            <button
                                type="button"
                                className="ok-btn"
                                onClick={() => {
                                    setForm({
                                        Customer_Code: JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
                                        mode: "",
                                        Dox_Spx: "",
                                        Rate_Mode: "",
                                        FromDate: firstDayOfMonth,
                                        ToDate: today,
                                    });
                                    fileInputRef.current.value = "";
                                }}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="ok-btn"
                                onClick={ 
                                    handleDownloadTemplate
                                }
                                style={{display:"flex",gap:"2px",alignItems:"center"}}
                            >
                                <span>Excel</span><MdFileDownload style={{marginTop:"3px",fontSize:"18px"}}/>
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
}

export default BulkImport;